angular.module('impactx.rfxsupplier').controller('RfxEditConditionDialogCtrl', RfxEditConditionDialogCtrl);

RfxEditConditionDialogCtrl.$inject = ['$scope', '$mdDialog', 'TranslationService', 'dataGen'];

function RfxEditConditionDialogCtrl($scope, $mdDialog, TranslationService, dataGen) {
    var ctrl = this;

    var itemCache;

    ctrl.trns.save = TranslationService.get('save');
    ctrl.trns.abort = TranslationService.get('abort');

    // only show positive value in input-field
    if (impactX.isDefined(ctrl, 'conditionItem.price.netValue')) {
        var value = ctrl.conditionItem.price.netValue.value;
        ctrl.conditionItem.price.netValue.value = Math.abs(value);
    }

    ctrl.toggleFreeEntry = function() {
        var item = JSON.parse(JSON.stringify(ctrl.conditionItem));
        updateItem(itemCache);
        itemCache = item;
    }

    ctrl.updateDialog = function (selected) {
        if (selected && selected.id) {
            dataGen.getData({}, {disId: selected.id, baseTaxRate: ctrl.baseItemTax, cscId: ctrl.cscId}, "/rfx/supplier/conditionselected").then(function (result) {
                if (result && result.data) {
                    updateItem(result.data);
                }
            });
        }
    }

    function updateItem(itemData) {
        if (itemData) {
            ctrl.conditionItem.conditionType.selected = itemData.conditionType.selected;
            ctrl.conditionItem.isRelative.setId = itemData.isRelative.setId;
            ctrl.conditionItem.name.value = itemData.name.value;
            ctrl.conditionItem.price.netValue.value = itemData.price.netValue.value;
            ctrl.conditionItem.price.currency.selected = itemData.price.currency.selected;
            ctrl.conditionItem.price.taxRate.selected = itemData.price.taxRate.selected;
            ctrl.conditionItem.price.taxRate.readOnly = itemData.price.taxRate.readOnly;
            ctrl.conditionItem.valueRate.value = itemData.valueRate.value;
        }
        else {
            ctrl.conditionItem.conditionType.selected = undefined;
            ctrl.conditionItem.isRelative.setId = undefined;
            ctrl.conditionItem.name.value = undefined;
            ctrl.conditionItem.price.netValue.value = undefined;
            ctrl.conditionItem.price.currency.selected = undefined;
            ctrl.conditionItem.price.taxRate.selected = undefined;
            ctrl.conditionItem.price.taxRate.readOnly = false;
            ctrl.conditionItem.valueRate.value = undefined;
        }
    }

    ctrl.save = function () {
        $mdDialog.hide({item: ctrl.conditionItem});
    }

    ctrl.abort = function () {
        $mdDialog.cancel();
    }
}